import SelectFilter from '../../organisms/SelectFilter';
import { DeliveryChannel, DeliverySigner, deliveryKeyOf } from './deliveryChannels';

interface SignerDeliveryChannelsProps {
    signers: DeliverySigner[];
    supportsPhoneDelivery: boolean;
    value: Record<string, DeliveryChannel>;
    onChange: (key: string, channel: DeliveryChannel) => void;
}

const CHANNEL_OPTIONS: { value: DeliveryChannel; label: string; requiresPhone: boolean }[] = [
    { value: 'EMAIL', label: 'Só e-mail', requiresPhone: false },
    { value: 'SMS', label: 'E-mail + SMS', requiresPhone: true },
    { value: 'WHATSAPP', label: 'E-mail + WhatsApp', requiresPhone: true },
];

export default function SignerDeliveryChannels({ signers, supportsPhoneDelivery, value, onChange }: SignerDeliveryChannelsProps) {
    if (!supportsPhoneDelivery) {
        return null;
    }

    return (
        <div>
            <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Canais de Notificação</label>
            <div className="space-y-2">
                {signers.map((signer) => {
                    const key = deliveryKeyOf(signer);
                    return (
                        <div key={key} className="flex items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm dark:border-slate-700 dark:bg-slate-800/50">
                            <div className="min-w-0">
                                <p className="font-medium text-gray-800 dark:text-gray-200 truncate">{signer.name} <span className="font-normal text-gray-400">({signer.role})</span></p>
                                {signer.hasPhone
                                    ? <p className="text-xs text-gray-400 dark:text-gray-500">{signer.phoneMasked}</p>
                                    : <p className="text-xs text-amber-600 dark:text-amber-400">Sem celular cadastrado: recebe só por e-mail.</p>}
                            </div>
                            <SelectFilter
                                id={`delivery-channel-${key}`}
                                label="Envio"
                                ariaLabel={`Canal de entrega de ${signer.name} (${signer.role})`}
                                value={value[key] ?? 'EMAIL'}
                                onChange={(channel) => onChange(key, channel as DeliveryChannel)}
                                options={CHANNEL_OPTIONS.map((option) => ({
                                    value: option.value,
                                    label: option.label,
                                    disabled: option.requiresPhone && !signer.hasPhone,
                                }))}
                                className="w-48 shrink-0"
                            />
                        </div>
                    );
                })}
            </div>
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">Todos recebem por e-mail. SMS e WhatsApp vão para o celular cadastrado.</p>
        </div>
    );
}
